<div class="user-page-container">
  <ng-content></ng-content>
  <!--  <app-settings-content></app-settings-content>-->
</div>
